import { render, staticRenderFns } from "./OkrFormNew.vue?vue&type=template&id=4c7bd44c&scoped=true"
import script from "./OkrFormNew.vue?vue&type=script&lang=js"
export * from "./OkrFormNew.vue?vue&type=script&lang=js"
import style0 from "./OkrFormNew.vue?vue&type=style&index=0&id=4c7bd44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7bd44c",
  null
  
)

export default component.exports